//#region import libraries
import React from 'react';
//bootstrap
import { Col, Row } from 'react-bootstrap';
//media-query
import { useMediaQuery } from 'react-responsive'
//styles
import { Colors } from '_styles';
//#endregion

const TeamMember = ({ image, name, position, bio }) => {

    const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })

    const bioMobile = {
        fontSize: 12,
        fontWeight: 100,
        paddingRight: 30
    };

    const nameMobile = {
        fontSize: 16,
        fontWeight: 300,
        paddingRight: 30
    };

    const titleMobile = {
        fontSize: 12,
        fontWeight: 100,
        paddingRight: 30
    };

    if (!isPhone) {
        return (
            <>
                <Row className="justify-content-md-center mt-5">
                    <Col>
                        <h3>{name}</h3>
                        <p style={{ color: Colors.TEXT_COLOR }}>{position}</p>
                        <p style={{ color: Colors.TEXT_COLOR }} className="fw-lighter fs-4">{bio}</p>
                    </Col>
                    <Col xs lg='3'>
                        <img
                            src={image}
                            className='ProfileImage'
                            style={{ height: 185, width: 'auto' }}
                        />
                    </Col>
                </Row>
            </>
        );
    }
    else {
        return (
            <>
                <Row className="mt-3">
                    <Col>
                        <img
                            src={image}
                            width={200}
                            height={200}
                            style={{ borderRadius: '50%', padding: '10px' }}
                        />
                    </Col>
                    <Col className='mt-4'>
                        <p style={nameMobile}>{name}</p>
                        <p style={titleMobile}>{position}</p>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col>
                        <p style={bioMobile}>{bio}</p>
                    </Col>
                </Row>

            </>
        );
    }
};

export default TeamMember;

